import axios from "../../../services/axios";
import React, { useEffect, useRef, useState } from "react";
import { Button, Form } from "react-bootstrap";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Editor } from "@tinymce/tinymce-react";
import { notify } from "../../../components/toastify/toast";

const EditRecieps = () => {
  const [reciepeEdit, setReciepeEdit] = useState({
    seoTitle: "",
    seoUrlTitle: "",
    seoSummary: "",
    seoKeyword: "",
    title: "",
    summary: "",
    body: "",
    oldImage: "",
    oldSeoImage: "",
    seoImageFile: null,
    imageFile: null,
    isDeleteImage: false,
    isDeleteSeoImage: false,
    isPublish: "",
  });

  const token = localStorage.getItem("token");
  const subsystemKey = localStorage.getItem("subsystemKey");
  const { id } = useParams();
  const navigate = useNavigate();
  // const [msg, setMsg] = useState("");
  const [imgFileState, setImgFileState] = useState({ file: "" });
  const [seoImgstate, setSeoImgState] = useState({ file: "" });
  const imageFileRef = useRef(null);
  const seoImageFileRef = useRef(null);
  const editorRef = useRef();

  //error state
  const [error400, setError400] = useState({});

  const GetEditedData = async () => {
    const response = await axios.get(`/Api/V1/Admin/Recipe/get-recipe/${id}`, {
      headers: {
        Authorization: token,
        SubSystemKey: subsystemKey,
      },
    });
    return response.data.data;
  };

  useEffect(() => {
    const fetchApi = async () => {
      setReciepeEdit(await GetEditedData());
    };
    fetchApi();
  }, []);

  //handleEdit
  const handleEdit = (e) => {
    setReciepeEdit({ ...reciepeEdit, [e.target.name]: e.target.value });
  };

  const handleFileEdit = (e, fileType) => {
    if (fileType === "main") {
      reciepeEdit.imageFile = e.target.files[0];
      setImgFileState({ file: URL.createObjectURL(e.target.files[0]) });
      reciepeEdit.isDeleteImage = false;
    } else {
      reciepeEdit.seoImageFile = e.target.files[0];
      setSeoImgState({ file: URL.createObjectURL(e.target.files[0]) });
      reciepeEdit.isDeleteSeoImage = false;
    }
    setReciepeEdit({ ...reciepeEdit });
  };

  //handle is publish
  const handleEditIsPublish = () => {
    reciepeEdit.isPublish = !reciepeEdit.isPublish;
    setReciepeEdit({ ...reciepeEdit });
  };

  //delete image
  const handleDeleteImg = (fileType) => {
    if (fileType === "main") {
      reciepeEdit.oldImage = null;
      setImgFileState({ file: "" });
      imageFileRef.current.value = null;
      reciepeEdit.isDeleteImage = true;
    } else {
      reciepeEdit.oldSeoImage = null;
      setSeoImgState({ file: "" });
      seoImageFileRef.current.value = null;
      reciepeEdit.isDeleteSeoImage = true;
    }
    setReciepeEdit({ ...reciepeEdit });
  };

  const submitHandler = async (e) => {
    e.preventDefault();
    const formData = new FormData();

    formData.append("SeoTitle", reciepeEdit.seoTitle);
    formData.append("SeoUrlTitle", reciepeEdit.seoUrlTitle);
    formData.append("SeoSummary", reciepeEdit.seoSummary);
    formData.append("SeoKeyword", reciepeEdit.seoKeyword);
    formData.append("Title", reciepeEdit.title);
    formData.append("Summary", reciepeEdit.summary);
    formData.append(
      "Body",
      (reciepeEdit.body = editorRef.current.getContent())
    );
    formData.append("SeoImageAlt", reciepeEdit.seoImageAlt);
    formData.append("ImageAlt", reciepeEdit.imageAlt);
    formData.append("ImageFile", reciepeEdit.imageFile);
    formData.append("SeoImageFile", reciepeEdit.seoImageFile);
    formData.append("IsDeleteImage", reciepeEdit.isDeleteImage);
    formData.append("IsDeleteSeoImage", reciepeEdit.isDeleteSeoImage);
    formData.append("Id", id);
    formData.append("IsPublish", reciepeEdit.isPublish);

    var config = {
      method: "post",
      url: "/Api/V1/Admin/Recipe/edit-recipe",
      headers: {
        Authorization: token,
        SubSystemKey: subsystemKey,
        "Content-Type": "multipart/form-data",
      },
      data: formData,
    };

    axios(config)
      .then((response) => {
        notify(response.data.message, "success");
        // setMsg(response.data.message);

        // setTimeout(() => {
        //   navigate("/recieps");
        // }, 2000);
      })
      .catch(function (error) {
        if (error.response.data.message) {
          notify(error.response.data.message, "error");
        }

        if (error.response.status === 400) {
          for (const item in error.response.data.errors) {
            error400[item] = error.response.data.errors[item][0];
          }
          setError400({ ...error400 });
        }
        if (error.response.status === 500) {
          notify("خطایی در سرور رخ داده است", "error");
        }
      });
  };

  return (
    <div className="container">
      <nav
        aria-label="breadcrumb"
        className="d-flex justify-content-start fw-bold m-1"
      >
        <ol className="breadcrumb">
          <li>
            <Link to="/dashbord" className=" text-decoration-none">
              داشبورد /
            </Link>
          </li>
          <li>
            <Link to="/recieps" className=" text-decoration-none me-1">
              دستور پخت /
            </Link>
          </li>
          <li className="breadcrumb-item active me-1" aria-current="page">
            ویرایش دستور پخت
          </li>
        </ol>
      </nav>
      <Form
        className="border p-3 w-100 shadow rounded"
        onSubmit={(e) => submitHandler(e)}
      >
        <Form.Group className="mb-5">
          <div className="w-100 m-2 shadow p-2 card d-flex flex-row">
            <div className="w-50 shadow p-2 m-2 rounded card ">
              <Form.Label className="mb-2 card-header">
                عنوان دستورپخت
              </Form.Label>
              <Form.Control
                type="text"
                name="title"
                value={reciepeEdit.title}
                onChange={(e) => handleEdit(e)}
                placeholder="عنوان دستورپخت را وارد کنید "
                className="mb-2"
                autoComplete="off"
                // dir='ltr'
              />
              {error400.Title && (
                <div className="alert alert-danger p-1 m-1">
                  {error400.Title}
                </div>
              )}

              <Form.Label>خلاصه</Form.Label>
              <Form.Control
                as="textarea"
                name="summary"
                value={reciepeEdit.summary}
                onChange={(e) => handleEdit(e)}
                placeholder="خلاصه ای از توضیحات را وارد کنید "
                className="mb-2"
                autoComplete="off"
                rows="3"
                cols="3"
                // dir='ltr'
              />
              {error400.Summary && (
                <div className="alert alert-danger p-1 m-1">
                  {error400.Summary}
                </div>
              )}

              <Form.Label>متن دستورپخت</Form.Label>
              <Editor
                onInit={(event, editor) => (editorRef.current = editor)}
                init={{
                  selector: "textarea",
                  menubar: "false",
                  plugins: "link image code",
                  directionality: "ltr",
                  toolbar:
                    "| undo redo | h1 h2 h3 h4 h5 h6 | styleselect | forecolor | bold italic | alignleft aligncenter alignright alignjustify | outdent indent | link image | code ",
                  language: "fa",
                  extended_valid_elements : 'script[type|src],style,div[class|style],span[class|style],iframe[src|allowFullScreen|webkitallowfullscreen|mozallowfullscreen]',
                }}
                initialValue={reciepeEdit.body}
              />
              {error400.Body && (
                <div className="alert alert-danger p-1 m-1">
                  {error400.Body}
                </div>
              )}

              <Form.Check
                type="switch"
                id="custom-switch"
                label="انتشار در سایت"
                className="w-25 mt-4"
                value={reciepeEdit.isPublish}
                checked={reciepeEdit.isPublish}
                onChange={(e) => handleEditIsPublish(e)}
              />
            </div>

            <div className="w-50 m-2 shadow p-2 card ">
              <Form.Label className="mb-2 card-header">سئو</Form.Label>
              <Form.Control
                type="text"
                name="seoTitle"
                value={reciepeEdit.seoTitle}
                onChange={(e) => handleEdit(e)}
                placeholder="عنوان سئو را وارد کنید"
                autoComplete="off"
              />
              {error400.SeoTitle && (
                <div className="alert alert-danger p-1 m-1">
                  {error400.SeoTitle}
                </div>
              )}

              <Form.Label className="">خلاصه ای از سئو</Form.Label>
              <Form.Control
                as="textarea"
                name="seoSummary"
                value={reciepeEdit.seoSummary}
                onChange={(e) => handleEdit(e)}
                placeholder="خلاصه سئو را وارد کنید"
                autoComplete="off"
              />
              {error400.SeoSummary && (
                <div className="alert alert-danger p-1 m-1">
                  {error400.SeoSummary}
                </div>
              )}

              <Form.Label className="">عنوان در آدرس</Form.Label>
              <Form.Control
                type="text"
                name="seoUrlTitle"
                value={reciepeEdit.seoUrlTitle}
                onChange={(e) => handleEdit(e)}
                placeholder="عنوان در آدرس سئو را وارد کنید"
                autoComplete="off"
              />
              {error400.SeoUrlTitle && (
                <div className="alert alert-danger p-1 m-1">
                  {error400.SeoUrlTitle}
                </div>
              )}

              <Form.Label className="">کلمات کلیدی</Form.Label>
              <Form.Control
                as="textarea"
                name="seoKeyword"
                value={reciepeEdit.seoKeyword}
                onChange={(e) => handleEdit(e)}
                placeholder="کلمات کلیدی سئو را وارد کنید"
                autoComplete="off"
              />
              {error400.SeoKeyword && (
                <div className="alert alert-danger p-1 m-1">
                  {error400.SeoKeyword}
                </div>
              )}
            </div>
          </div>

          <div className="w-100 m-2 shadow p-2 card d-flex flex-row">
            <div className="w-50 m-2 shadow p-2 card">
              <Form.Label className="card-header mb-2">تصویر اصلی</Form.Label>
              <Form.Control
                ref={imageFileRef}
                type="file"
                name="imageFile"
                // value={}
                onChange={(e) => handleFileEdit(e, "main")}
                autoComplete="off"
                className="mb-2 "
              />
              {!imgFileState.file ? (
                reciepeEdit.oldImage && (
                  <div className="card d-flex flex-column">
                    <img
                      className="shadow card-img img-fluid image-style"
                      src={`${window.Configs["admin-base-url"]}/Api/V1/ui/Content/Image?entityName=1&imageName=${reciepeEdit.oldImage}`}
                      alt="imageFile"
                    />
                    <Button
                      className="btn btn-danger "
                      size="sm"
                      type="button"
                      onClick={() => handleDeleteImg("main")}
                    >
                      حذف عکس{" "}
                    </Button>
                  </div>
                )
              ) : (
                <div className="card d-flex flex-column">
                  <img
                    className="shadow card-img img-fluid image-style"
                    src={imgFileState.file}
                    alt="imageFile"
                  />
                  <Button
                    className="btn btn-danger "
                    size="sm"
                    type="button"
                    onClick={() => handleDeleteImg("main")}
                  >
                    حذف عکس{" "}
                  </Button>
                </div>
              )}
            </div>

            <div className="w-50 m-2 shadow p-2 card">
              <Form.Label className="card-header mb-2">تصویر سئو</Form.Label>
              <Form.Control
                ref={seoImageFileRef}
                type="file"
                name="seoImageFile"
                onChange={(e) => handleFileEdit(e, "seo")}
                className="mb-2 "
                autoComplete="off"
              />
              {!seoImgstate.file ? (
                reciepeEdit.oldSeoImage && (
                  <div className="card d-flex flex-column">
                    <img
                      className="shadow card-img img-fluid image-style"
                      src={`${window.Configs["admin-base-url"]}/Api/V1/ui/Content/Image?entityName=1&imageName=${reciepeEdit.oldSeoImage}`}
                      alt="seoImage"
                    />
                    <Button
                      className="btn btn-danger"
                      size="sm"
                      onClick={() => handleDeleteImg("seo")}
                    >
                      حذف عکس{" "}
                    </Button>
                  </div>
                )
              ) : (
                <div className="card d-flex flex-column">
                  <img
                    className="shadow card-img img-fluid image-style "
                    src={seoImgstate.file}
                    alt="seoImage"
                  />
                  <Button
                    className="btn btn-danger"
                    size="sm"
                    onClick={() => handleDeleteImg("seo")}
                  >
                    حذف عکس{" "}
                  </Button>
                </div>
              )}
            </div>
          </div>
        </Form.Group>

        <Button
          className="action_btn mt-2 p-2"
          variant="primary"
          type="submit"
          size="sm"
        >
          ثبت ویرایش
        </Button>
        <Link to="/recieps">
          <Button
            className="action_btn mt-2 p-2 mx-2"
            variant="secondary"
            size="sm"
          >
            بازگشت
          </Button>
        </Link>
        {/* {msg && <div className="alert alert-success mt-2">{msg}</div>} */}
      </Form>
    </div>
  );
};

export default EditRecieps;
